import React from "react";
import { Modal, Button } from "react-bootstrap";
import Lottie from "lottie-react";
import successAnimation from "../../assets/animations/Success.json";

// Default messages based on entity type and operation
const DEFAULT_MESSAGES = {
  employee: {
    add: "Employee added successfully.",
    update: "Employee updated successfully.",
  },
  client: {
    add: "Client added successfully.",
    update: "Client updated successfully.",
  },
  company: {
    add: "Company added successfully.",
    update: "Company updated successfully.",
  },
};

const EditSuccessPopup = ({
  show,
  onHide,
  entityType = "employee",
  operationType = "update",
  customMessage,
  title = "Success",
}) => {
  const getMessage = () => {
    if (customMessage) return customMessage;

    const entityMessages = DEFAULT_MESSAGES[entityType];
    if (entityMessages) {
      return entityMessages[operationType] || entityMessages.update;
    }

    return "Operation completed successfully.";
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="dd-success-modal"
      className="dd_paid_success_popup"
    >
      <Modal.Body>
        <div className="dd-success-wrapper" style={{ textAlign: "center" }}>
          <div
            className="dd-success-icon"
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "15px",
            }}
          >
            <Lottie
              animationData={successAnimation}
              loop={true}
              style={{ width: 100, height: 100 }}
            />
          </div>

          <h4
            className="dd-success-title"
            style={{ textAlign: "center", marginBottom: "10px" }}
          >
            {title}
          </h4>

          <p
            className="dd-success-text"
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            {getMessage()}
          </p>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button className="dd-success-btn btn_primary" onClick={onHide}>
              OK
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditSuccessPopup;
